var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form task-w m-2 m-lg-4"},[_c('dash-task')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }